import * as React from 'react';
import { Header1 } from '@cian/ui-kit';
import { Layout } from '../Layout';
import * as styles from './Projects.css';

interface IProjectsProps {
  filters: React.ReactElement;
  content: React.ReactElement;
  switch: React.ReactElement;
}

export function Projects(props: IProjectsProps) {
  const { filters, content, switch: switchComponent } = props;

  return (
    <section id="projects" className={styles['projects']}>
      <Layout>
        <div className={styles['projects__title']}>
          <Header1>Проекты</Header1>
          {switchComponent}
        </div>

        {filters}
        {content}
      </Layout>
    </section>
  );
}
